<template lang="html">
  <span>🐻</span>
</template>

<script>
export default {
  name: "UserLoader",
  mounted() {
    if (!("id" in this.$store.state.user)) this.$store.dispatch("loadUserData");
  }
};
</script>

<style lang="css" scoped></style>
